import React from 'react'
import {StaticQuery, graphql} from 'gatsby'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import WidthContainer from '../WidthContainer'
import {Linkedin, Meetup, Twitter} from '../../components/SocialsIcons'

import Markdown from '../Markdown'
import cdLogo from './images/cdLogo.svg'
import WavyBackground from '../WavyBackground'

const phoneBreakpoint = '@media only screen and (max-width: 930px)'

const FooterContainer = styled(WavyBackground)`
	color: white;
	position: relative;
	font-size: ${props => props.theme.fontSizes.smallest};
	font-weight: ${props => props.theme.fontWeights.regular};
	
	a {
		color: white;
		
		&:hover {
			text-decoration: underline;
		}
	}
`
FooterContainer.defaultProps = {
	type: 'footer',
}

const InnerContainer = styled(WidthContainer)`
	display: flex;
	justify-content: space-between;
	padding-top: 5.5rem;
	
	${phoneBreakpoint} {
		flex-direction: column;
	}
`

const ColumnsContainer = styled.div`
	display: flex;
	margin: -0.5rem -3.125rem;
	flex-wrap: wrap;
`

const Column = styled.div`
	margin: .5rem 3.125rem;
`

const ColumnTitle = styled.div`
	font-size: ${props => props.theme.fontSizes.extraSmall};
	color: ${props => props.theme.colors.main};
	text-transform: uppercase;
	font-weight: ${props => props.theme.fontWeights.bold};
	margin-bottom: 1rem;
`

const ColumnContent = styled(Markdown)`
	
	p:last-of-type {
		margin-bottom: 0;
	}
`
const SocialsContainer = styled.div`
	text-align: right;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	
	${phoneBreakpoint} {
		margin-top: 4rem;
		text-align: left;
		align-items: center;
	}
`

const IconsContainer = styled.div`
	margin: 0 -1rem 2.7rem;
	display: flex;
	align-items: center;
`

const IconLink = styled.a`
	margin: 0 1rem;
	transform: scale(1);
	transition: ${props => props.theme.transitions.smallElements} ease;
	
	&:hover {
		transform: scale(1.2);
	}
	
	svg {
		height: 1.6rem;
		fill: white;
	}
`

const CdContainer = styled.a`
	font-weight: ${props => props.theme.fontWeights.regular};
	display: flex;
	flex-direction: column;
	align-items: flex-end;
`

const CdLogo = styled.img`
	margin-bottom: 0.4rem;
`

CdLogo.defaultProps = {
	alt: 'Creative Dock',
	src: cdLogo,
}

const CdText = styled.div`

`

const Footer = ({underColor}) => <StaticQuery
	query={graphql`{
		topBar: file(relativePath: {eq: "global/footer.json"}) {
			childGlobalJson {
				columns {
					title
					contentMd
				}
				socials {
					twitter
					meetup
					linkedin
				}
			}
		}
	}`}
	render={data => {
		const {columns, socials} = data.topBar.childGlobalJson
		return <FooterContainer underColor={underColor}>
			<InnerContainer>
				<ColumnsContainer>
					{columns.map(one => <Column key={one.title}>
						<ColumnTitle>{one.title}</ColumnTitle>
						<ColumnContent text={one.contentMd}/>
					</Column>)}
				</ColumnsContainer>
				<SocialsContainer>
					<IconsContainer>
						<IconLink target='_blank' href={socials.twitter}>
							<Twitter/>
						</IconLink>
						<IconLink target='_blank' href={socials.meetup}>
							<Meetup/>
						</IconLink>
						<IconLink target='_blank' href={socials.linkedin}>
							<Linkedin/>
						</IconLink>
					</IconsContainer>
					<CdContainer target='_blank' href='https://creativedock.cz'>
						<CdLogo/>
						<CdText>
							Developed by <b>Creative Dock</b>
						</CdText>
					</CdContainer>
				</SocialsContainer>
			</InnerContainer>
		</FooterContainer>
	}}/>

Footer.defaultProps = {
	underColor: PropTypes.string.isRequired,
}

Footer.defaultProps = {
	underColor: 'white',
}

export default Footer
